export interface JournalEntryReportsFilterType {
  startDateFrom: Date | null;
  endDateFrom: Date | null;
}

export const defaultJournalEntryReportsFilter =
  (): JournalEntryReportsFilterType => ({
    startDateFrom: null,
    endDateFrom: null,
  });
